import React from "react";
import { Doughnut } from "react-chartjs-2";

const RoleDistributionChart = ({ isStatsLoading, roleChartData }) => {
  return (
    <div className="card border-0 shadow-sm h-100">
      <div className="card-header bg-white py-3">
        <h6 className="m-0 fw-bold text-primary">Distribusi Role</h6>
      </div>
      <div className="card-body d-flex align-items-center justify-content-center">
        {!isStatsLoading && (
          <div style={{ height: "220px", width: "100%" }}>
            <Doughnut
              data={roleChartData}
              options={{
                maintainAspectRatio: false,
                plugins: { legend: { position: "bottom" } },
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default RoleDistributionChart;
